import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile: "",
    password: "",
    role_id: "",
    party_id: "",
    district_id: "",
    sub_district_id: "",
    city_id: "",
    ward_id: "",
  });

  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState([]);
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [wards, setWards] = useState([]);
  const [noCities, setNoCities] = useState(false);
  const [noWards, setNoWards] = useState(false);

  const loadDropdowns = async () => {
    try {
      const rolesData = await apiFetch("super_admin/list_roles");
      const partiesData = await apiFetch("super_admin/list_parties");
      const districtsData = await apiFetch("super_admin/list_district");

      const rolesList = rolesData.roles || rolesData;

      setRoles(rolesList);
      setParties(partiesData.parties || partiesData);
      setDistricts(districtsData.districts || districtsData);

      const leaderRole = rolesList.find(
        (r) => r.role_name.toLowerCase() === "leader"
      );

      if (leaderRole) {
        setFormData((prev) => ({
          ...prev,
          role_id: leaderRole.role_id,
        }));
      }
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleDistrictChange = async (e) => {
    const districtId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      district_id: districtId,
      sub_district_id: "",
      city_id: "",
      ward_id: "",
    }));

    setSubDistricts([]);
    setCities([]);
    setWards([]);
    setNoCities(false);
    setNoWards(false);

    if (!districtId) return;

    try {
      const subDistrictData = await apiFetch(
        `super_admin/get_all_subdistrict?district_id=${districtId}`
      );
      setSubDistricts(subDistrictData.subdistricts || subDistrictData);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleSubDistrictChange = async (e) => {
    const subDistrictId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      sub_district_id: subDistrictId,
      city_id: "",
      ward_id: "",
    }));

    if (errors.sub_district_id) setErrors((prev) => ({ ...prev, sub_district_id: "" }));
    setNoCities(false);
    setNoWards(false);

    if (!subDistrictId) {
      setCities([]);
      setWards([]);
      return;
    }

    try {
      const citiesData = await apiFetch(
        `super_admin/cities_by_subdistrict?subdistrict_id=${subDistrictId}`
      );

      const cityList = citiesData.cities || citiesData;

      if (!cityList || cityList.length === 0) {
        setCities([]);
        setNoCities(true);
        return;
      }

      setCities(cityList);
      setNoCities(false);
      setWards([]);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleCityChange = async (e) => {
    const cityId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      city_id: cityId,
      ward_id: "",
    }));

    if (errors.city_id) setErrors((prev) => ({ ...prev, city_id: "" }));
    setNoWards(false);

    if (!cityId) {
      setWards([]);
      return;
    }

    try {
      const wardsData = await apiFetch(
        `super_admin/ward_by_cities?city_id=${cityId}`
      );

      const wardList = wardsData.wards || wardsData;

      if (!wardList || wardList.length === 0) {
        setWards([]);
        setNoWards(true);
        return;
      }

      setWards(wardList);
      setNoWards(false);
    } catch (error) {
      alert(error.message);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) {
      newErrors.full_name = "Full Name is required";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email Address is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile Number must be 10 digits";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!formData.role_id) {
      newErrors.role_id = "Please select a role";
    }
    if (!formData.ward_id) {
      newErrors.ward_id = "Please select a ward";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      await apiFetch("super_admin/add_user", {
        method: "POST",
        body: JSON.stringify(formData),
      });

      alert("User added successfully");
      navigate("/users");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                👤 नवीन वापरकर्ता जोडा (Add New User)
              </h4>
              <small className="text-white-50">Create and assign user credentials</small>
            </div>
          </div>

          <Link to="/users" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            User List
          </Link>
        </div>

        {/* Main Card */}
        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                {/* Full Name */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    placeholder="Enter full name"
                  />
                  {errors.full_name && (
                    <small className="text-danger d-block mt-1">{errors.full_name}</small>
                  )}
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@mail.com"
                  />
                  {errors.email && (
                    <small className="text-danger d-block mt-1">{errors.email}</small>
                  )}
                </div>

                {/* Mobile */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Mobile Number</label>
                  <input
                    type="text"
                    className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="10-digit mobile number"
                  />
                  {errors.mobile && (
                    <small className="text-danger d-block mt-1">{errors.mobile}</small>
                  )}
                </div>

                {/* Password */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Minimum 6 characters"
                  />
                  {errors.password && (
                    <small className="text-danger d-block mt-1">{errors.password}</small>
                  )}
                </div>

                {/* Role */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    Select Role <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.role_id ? "is-invalid" : ""}`}
                    name="role_id"
                    value={formData.role_id || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select Role</option>
                    {roles.map((r) => (
                      <option key={r.role_id} value={r.role_id}>
                        {r.role_name}
                      </option>
                    ))}
                  </select>
                  {errors.role_id && (
                    <small className="text-danger d-block mt-1">{errors.role_id}</small>
                  )}
                </div>

                {/* Party */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Select Party</label>
                  <select
                    className="form-select"
                    name="party_id"
                    value={formData.party_id}
                    onChange={handleChange}
                  >
                    <option value="">Select Party</option>
                    {parties.map((p) => (
                      <option key={p.party_id} value={p.party_id}>
                        {p.party_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* District */}
                <div className="col-md-3">
                  <label className="form-label fw-semibold">District</label>
                  <select
                    className="form-select"
                    name="district_id"
                    value={formData.district_id || ""}
                    onChange={handleDistrictChange}
                  >
                    <option value="">Select District</option>
                    {districts.map((d) => (
                      <option key={d.district_id} value={d.district_id}>
                        {d.district_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Sub District */}
                <div className="col-md-3">
                  <label className="form-label fw-semibold">Sub District</label>
                  <select
                    className="form-select"
                    name="sub_district_id"
                    value={formData.sub_district_id || ""}
                    onChange={handleSubDistrictChange}
                    disabled={!formData.district_id}
                  >
                    <option value="">
                      {!formData.district_id ? "Select District First" : "Select Sub District"}
                    </option>
                    {subDistricts.map((sd) => (
                      <option key={sd.subdistrict_id} value={sd.subdistrict_id}>
                        {sd.subdistrict_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* City */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">City</label>
                  <select
                    className="form-select"
                    name="city_id"
                    value={formData.city_id || ""}
                    onChange={handleCityChange}
                    disabled={!formData.sub_district_id || noCities}
                  >
                    <option value="">
                      {!formData.sub_district_id
                        ? "Select Sub District First"
                        : noCities
                        ? "No City Found"
                        : "Select City"}
                    </option>
                    {cities.map((c) => (
                      <option key={c.city_id} value={c.city_id}>
                        {c.city_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Ward */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Ward <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.ward_id ? "is-invalid" : ""}`}
                    name="ward_id"
                    value={formData.ward_id || ""}
                    onChange={handleChange}
                    disabled={!formData.city_id || noWards}
                  >
                    <option value="">
                      {!formData.city_id
                        ? "Select City First"
                        : noWards
                        ? "No Ward Found"
                        : "Select Ward"}
                    </option>
                    {wards.map((w) => (
                      <option key={w.ward_id} value={w.ward_id}>
                        {w.ward_name} - प्रभाग क्रमांक {w.ward_number}
                      </option>
                    ))}
                  </select>
                  {errors.ward_id && (
                    <small className="text-danger d-block mt-1">{errors.ward_id}</small>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-4 text-end">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                  style={{ fontSize: "0.85rem" }}
                >
                  {loading ? "Saving..." : "Add User"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddUser;
